<template>
  <div class="retain_dialog_box">
    <div class="close_box"><IconCloseImg @click.native="clickClose" /></div>
    <!-- 倒计时 -->
    <div class="countdown_box">
      <span class="hour">{{ countdownTime.hour }}</span>
      <span class="minute">{{ countdownTime.minute }}</span>
      <span class="second">{{ countdownTime.second }}</span>
    </div>
    <!-- 二维码 -->
    <div class="qr_code">
      <span class="logo_mini" />
      <qrcode-vue
        :value="codeUrl" level="H"
        background="transparent" foreground="#7e0202" :size="160" />
    </div>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'
import IconCloseImg from '@/components/Icons/IconCloseImg.vue'

import { getNowToTomorrowTimer } from '@/common/utils'
import { ClientCloseSelf } from '@/api/clientApi'
import api from '@/api'
import { report } from '@/report'

export default {
  name: 'RetainDialog',

  components: { QrcodeVue, IconCloseImg },

  data () {
    return {
      codeUrl: '',
      countdownTime: { hour: '00', minute: '00', second: '00' }
    }
  },

  mounted () {
    this.updateConfigUrl()
  },

  destroyed () {
    this._timer && clearTimeout(this._timer)
  },

  methods: {
    updateConfigUrl () {
      const req = { data: { pos_code: 'kofficeside_login_outlet' } }
      api.common.adConfig(req).then(res => {
        this.codeUrl = res.data.list[0]?.items[0]?.url

        report('login', { actiontype: 'staywxshow', actionid: 0, ext: '' })

        if (this.codeUrl) { // 如果有配置，开启倒计时
          this.startCountDown()
        }
      })
    },

    startCountDown () {
      this._timer = setTimeout(() => {
        this.countdownTime = getNowToTomorrowTimer()
        this.startCountDown()
      }, 1000)
    },

    clickClose () {
      ClientCloseSelf()
    }
  }
}
</script>

<style lang="scss" scoped>
.retain_dialog_box {
  position: relative;
  box-sizing: border-box;
  width: 376px;
  height: 577px;
  margin: 6px;
  background: url(~@/assets/images/loginRetain/bg_login_retain.png) no-repeat center center;
  background-size: 100% 100%;
  box-shadow: $box_shadow_dialog;

  .close_box {
    position: absolute;
    right: 0;
  }

  .countdown_box {
    position: absolute;
    top: 44%;
    width: 100%;
    margin-top: -1px;
    span {
      position: absolute;
    }
    .hour { left: 40%; margin-left: 16px; }
    .minute { left: 40%; margin-left: 56px; }
    .second { left: 40%; margin-left: 98px; }
  }

  .qr_code {
    position: absolute;
    bottom: 84px;
    left: 50%;
    margin-left: -80px;
    .logo_mini{
      position: absolute;
      top: 50%;
      left: 50%;
      width: 40px;
      height: 40px;
      margin: -20px 0 0 -20px;
      background: url(~@/assets/images/logo_mini_bg.png) no-repeat center center;
      background-color: #ffe6b4;
      background-size: 36px 36px;
      border-radius: 4px;
    }
  }
}
</style>
